import { Table } from '@mantine/core';
import classNames from 'classnames';
import { type TableRow } from '../../../../types';
import styles from './Item.module.css';

interface ItemProps<Item> {
    row: TableRow<Item>;
    selectedRowKey?: TableRow<Item>['key'];
    onClick?: (item: Item) => void;
}

export const Item = <Item,>({ row, selectedRowKey, onClick }: ItemProps<Item>) => {
    const { key, cells, item } = row;

    const isSelected = selectedRowKey !== undefined && key === selectedRowKey;
    const isClickable = Boolean(onClick);

    const rowClasses = classNames(isClickable ? styles.row : '', isSelected ? styles.selectedRow : '');

    const handleRowClick = (item: Item) => () => {
        onClick?.(item);
    };

    return (
        <Table.Tr
            key={key}
            className={rowClasses}
            onClick={isClickable ? handleRowClick(item) : undefined}
        >
            {cells.map(({ key: cellKey, content }) => (
                <Table.Td
                    key={cellKey}
                    className={styles.td}
                >
                    {content}
                </Table.Td>
            ))}
        </Table.Tr>
    );
};
